/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RollingAverage } from './RollingAverage';
import {
    RollingAverageFromJSON,
    RollingAverageFromJSONTyped,
    RollingAverageToJSON,
    RollingAverageToJSONTyped,
} from './RollingAverage';

/**
 * Serializer for rolling average data request status and results.
 * @export
 * @interface RollingAverageDataRequest
 */
export interface RollingAverageDataRequest {
    /**
     * 
     * @type {Array<RollingAverage>}
     * @memberof RollingAverageDataRequest
     */
    responseData?: Array<RollingAverage> | null;
    /**
     * 
     * @type {string}
     * @memberof RollingAverageDataRequest
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof RollingAverageDataRequest
     */
    errorMessage?: string | null;
}

/**
 * Check if a given object implements the RollingAverageDataRequest interface.
 */
export function instanceOfRollingAverageDataRequest(value: object): value is RollingAverageDataRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function RollingAverageDataRequestFromJSON(json: any): RollingAverageDataRequest {
    return RollingAverageDataRequestFromJSONTyped(json, false);
}

export function RollingAverageDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RollingAverageDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'responseData': json['response_data'] === undefined ? undefined : json['response_data'] === null ? null : ((json['response_data'] as Array<any>).map(RollingAverageFromJSON)),
        'status': json['status'],
        'errorMessage': json['error_message'] === undefined ? undefined : json['error_message'] === null ? null : json['error_message'],
    };
}

export function RollingAverageDataRequestToJSON(json: any): RollingAverageDataRequest {
    return RollingAverageDataRequestToJSONTyped(json, false);
}

export function RollingAverageDataRequestToJSONTyped(value?: RollingAverageDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'response_data': value['responseData'] == null ? undefined : ((value['responseData'] as Array<any>).map(RollingAverageToJSON)),
        'status': value['status'],
        'error_message': value['errorMessage'],
    };
}

